import { Configuration } from 'rpc/runtime';

function getBaseConfig(): Configuration {
  return new Configuration({
    basePath: `${window.self.location.origin}/mep/rpc`,
    // middleware: [{
    //   post: async (context: ResponseContext) => {
    //     debugger;
    //     return context.response;
    //   },
    // }],
  });
}

function handleErrorResponse(error: Error): void {
  console.log(error);
}

export default {
  getBaseConfig,
  handleErrorResponse,
};
